"use client";

import * as React from "react";
import { FloatingLabelInput } from "./floating-label-input";

export function FloatingLabelInputDemo() {
  return <FloatingLabelInput label="Email" placeholder="Enter your email" />;
}
